import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { environment } from 'src/environments/environment';
import { AddfundPopupComponent } from '../addfund-popup/addfund-popup.component';
import { TournamentService } from 'src/app/tournamentpopup/tournament.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { CDK_CONNECTED_OVERLAY_SCROLL_STRATEGY_FACTORY } from '@angular/cdk/overlay/typings/overlay-directives';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '../app.state';
import { VerificationComponent } from '../verification/verification.component';
@Component({
  selector: 'app-confirmbox',
  templateUrl: './confirmbox.component.html',
  styleUrls: ['./confirmbox.component.scss']
})
export class ConfirmboxComponent implements OnInit {

  parameters: any; 
  time=0;
  assetURL :String;
  confirmDialogRef: MatDialogRef<ConfirmboxComponent>;
  schedulesData: any;
  redirect: String;
  darkMode= false;
  darkMode_ext= '';
  user:any;
  isUserOnLobby:boolean;
  constructor(private dialogRef: MatDialogRef<ConfirmboxComponent>,
    @Inject(MAT_DIALOG_DATA) private data, 
    private spinner: NgxSpinnerService,
    private tournamentService: TournamentService,
    public dialog: MatDialog,
    private activeRoute: ActivatedRoute,
    private store: Store<AppState>) { 
      this.parameters = data;
      if(typeof this.parameters.cancelBtn === 'undefined'){
        this.parameters.cancelBtn = true;
      }
      if(this.parameters.type === 'registration_completed_popup') {
        this.time = data.remaining_time;
      }
      if(this.parameters.type === 'game_schedules') {
        this.schedulesData = this.scheduleInfo(this.parameters.league_id, this.parameters.user_id);
      }
      if(this.parameters.type === 'first_deposit') {
        this.activeRoute.queryParams.subscribe(params => {
          this.redirect = "drafts/"+params['redirect'];
        });
      }
      this.store.select('DarkModeReducer').subscribe(state => {
        if (state.length > 0) {
          this.darkMode = state[0].isDarkMode;
          this.darkMode_ext = this.darkMode?'_icon-dark':'';
        }
      });
      this.store.select('authData').subscribe(state => {
        if(state[0]){
          this.user = state[0];
        }
      })
  }

  ngOnInit(){
    this.assetURL = `${environment.assetURL}`;
  }

  confirm(type){
    if(type === 'add-fund'){
      this.dialog.open(AddfundPopupComponent, {
        width: '850px',
        data : {'tab':1}
      }); 
    }
    else if (type == 'location-help') {
      window.location.href = `${environment.SITE_URL}` + '/location-help#chrome';
    }
    else if (type == 'location-accurate') {
      if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition((position)=>{
            this.spinner.show();
            const longitude = position.coords.longitude;
            const latitude = position.coords.latitude;
            this.tournamentService.geLocationData(longitude, latitude).subscribe(res => {
              this.spinner.hide();
              if (typeof(res['error_message']) !== 'undefined' && res['error_message'] != '') {
                this.confirmDialogRef = this.dialog.open(ConfirmboxComponent, {
                  width: '500px',
                  data: { 'title': "We're Sorry!", 'body': res['error_message'] + ' Please contact to support.' ,'type':'alert-box' }
                });
                this.confirmDialogRef.afterClosed().subscribe(res => {});
              }
              else if (typeof(res['status']) != 'undefined' && res['status'] == 'OK') {
                var country = '';
                var state = '';
                var resultData = [];
                if (typeof(res['results'][0].address_components) != 'undefined') {
                  resultData = res['results'][0].address_components;
                }
                else {
                  resultData = res['results'][res['results'].length - 2].address_components;
                }
                
                resultData.forEach((addr, i) => {
                  if (addr.types[0] == 'country' ) {
                    country = addr.long_name;
                  }
                  if (addr.types[0] == 'administrative_area_level_1' ) {
                    state = addr.long_name;
                  }
                });
                
                this.tournamentService.modifyUserLocation({state, country});
              }
            });
          });
      } else {
        this.confirmDialogRef = this.dialog.open(ConfirmboxComponent, {
          width: '500px',
          data: { 'title': "We're Sorry!", 'body': 'Geolocation is not Supported for this browser/OS. Please contact to support.' ,'type':'alert-box' }
        });
        this.confirmDialogRef.afterClosed().subscribe(res => {});
      }
    } else if(type == 'first_deposit'){
        this.isUserOnLobby = true;
        if(this.user.payment_verified === 'N' && this.user.verify_before_deposits ){
          setTimeout(()=>{
            this.openVerificationDialog();
          },500)
        }else{
          if(this.redirect) window.location.href = `${environment.SITE_URL}` + '/' + this.redirect;
        }
    } else if(type == 'deposit_success'){
        if(this.redirect) window.location.href = `${environment.SITE_URL}` + '/lobby/all';
    }
    this.dialogRef.close(1);
  }
  
  scheduleInfo(league_id, user_id) {
    this.tournamentService.getDraftPopupData(league_id, user_id, 'schedules').subscribe(res => {
      if (typeof res !== 'undefined' && res.status === 'success') {
        this.schedulesData = res.entities;
      }
    });
  }
  
  onNotify(val:number) { 
    if(val === 1000) {
      this.confirm('');
    }
  } 

  reload(){
    window.location.reload();
  }

  openVerificationDialog(){
    this.dialog.closeAll();
    this.dialog.open(VerificationComponent, {
      width:'500px',
      data: {
        user : this.user,
        lobby : this.isUserOnLobby
      }
    });
  }
}
